export default "__VITE_ASSET__DD6XsWez__"